var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.5H15.5V15.5H9.5V10.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5C11.9696 7.5 11.4609 7.71071 11.0858 8.08579C10.7107 8.46086 10.5 8.96957 10.5 9.5V10.5H14.5V9.5C14.5 8.96957 14.2893 8.46086 13.9142 8.08579C13.5391 7.71071 13.0304 7.5 12.5 7.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.7695C12.4506 12.7695 12.4022 12.7842 12.3611 12.8117C12.32 12.8391 12.288 12.8782 12.269 12.9239C12.2501 12.9695 12.2452 13.0198 12.2548 13.0683C12.2645 13.1168 12.2883 13.1613 12.3232 13.1963C12.3582 13.2313 12.4027 13.2551 12.4512 13.2647C12.4997 13.2744 12.55 13.2694 12.5957 13.2505C12.6414 13.2316 12.6804 13.1995 12.7079 13.1584C12.7353 13.1173 12.75 13.069 12.75 13.0195C12.75 12.9532 12.7237 12.8896 12.6768 12.8428C12.6299 12.7959 12.5663 12.7695 12.5 12.7695Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.4998H1.5C1.23478 11.4998 0.98043 11.3944 0.792893 11.2069C0.605357 11.0193 0.5 10.765 0.5 10.4998V2.50977C0.5 2.24455 0.605357 1.9902 0.792893 1.80266C0.98043 1.61512 1.23478 1.50977 1.5 1.50977H10.5C10.7652 1.50977 11.0196 1.61512 11.2071 1.80266C11.3946 1.9902 11.5 2.24455 11.5 2.50977V5.49977",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.5H11.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49536 2.5V0.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49536 2.5V0.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLock);
export default __webpack_public_path__ + "static/media/calendar-lock.0e406ab5052b797f6afe746e88e76a91.svg";
export { ForwardRef as ReactComponent };